import React, {Fragment, useEffect, useRef} from "react";
import {Box} from "@mui/system";
import {useDispatch} from "react-redux";
import _ from "lodash";
import {customFieldActions} from "_actions";
import AddCustomFieldEntry from "./AddCustomFieldEntry";
import AutoAddRequiredCustomFieldsToggle from "./AutoAddRequiredCustomFieldsToggle";
import CustomFieldItem from "./CustomFieldItem";
import useGetCustomFields from "./hooks/useGetCustomFields";
import styles from "../../../organizationMainStyles";
import NoDataView from "../../../EmptyStates/NoDataView";
import {
    customFieldActionsCreator
} from "../../../../Vote/Sections/BodySection/Response/CustomField/CustomFieldUtils";

export default function CustomFieldSetting({msgDataSource, mode}) {
    const dispatch = useDispatch();
    const effectRan = useRef(false);
    const msgDataSourceId = msgDataSource?.id;

    useEffect(() => {
        if (effectRan.current === false) {
            dispatch(customFieldActions.listCustomFields(msgDataSourceId, customFieldActionsCreator.settingsView));
            return () => effectRan.current = true;
        }
    }, [msgDataSourceId]);

    const filterCustomFieldByMasDataSourceId = (customFields, masDataSourceId) => {
        const result = customFields.find(item => item.masDataSourceId === masDataSourceId);
        return result ? result.customFields : [];
    }

    const {customFields, listCustomFieldsLoading} = useGetCustomFields();
    const filteredCustomFields = filterCustomFieldByMasDataSourceId(customFields, msgDataSourceId);

    const Content = () => {
        if (listCustomFieldsLoading) {
            return <Fragment />;
        }

        if (_.isEmpty(filteredCustomFields)) {
            return (
                <Box sx={{ mt: '15px' }}>
                    <NoDataView
                        description="No custom fields found. Click ‘Add new’ to create one"
                        style={{color: '#6b6b6b', fontFamily: 'larsseitRegular'}}
                    />
                </Box>
            );
        }

        return filteredCustomFields.map((customField, index) => (
            <Box key={index}>
                <CustomFieldItem customField={customField} />
            </Box>
        ));
    };


    return (
        <Box sx={styles.heading}>
            <Box sx={style.headingContainer}>
                <Box>Custom fields</Box>
                <Box>
                    <AddCustomFieldEntry msgDataSourceId={msgDataSource?.id}/>
                </Box>
            </Box>
            <AutoAddRequiredCustomFieldsToggle msgDataSource={msgDataSource}/>
            <Content />
        </Box>
    )
}

const style = {
    headingContainer: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    detailsContainer: {
        border: '1px solid #b6bebf',
        backgroundColor: '#F8F9F9',
        borderRadius: '10px',
        overflow: 'hidden',
        p: '15px',
        mt: '15px',
        mb: '16px',
    },
    detailsHeader: {
        mb: '5px',
        display: 'flex',
        justifyContent: 'space-between'
    },
    deleteIcon: {
        color: '#AC2925',
        fontSize: '22px',
        textAlign: 'right'
    },
}